module.exports = {
	extends: [
		'/',
		'base',
		'master',
		'master'
	]
};